// extracted by mini-css-extract-plugin
export default {"reports":"userReports_reports__ZMWpT"};